import {
  Rocket, Library, MessageSquareText, FolderKanban, Lightbulb,
  Play, Trophy, HelpCircle, ShieldCheck,
} from "lucide-react";

/**
 * Maps KB category slugs to minimal Lucide icons.
 * Lucide: MIT license, consistent 24px stroke icons.
 * https://lucide.dev
 */
const ICON_MAP = {
  "comenzar-aqui": Rocket,
  "biblioteca": Library,
  "prompt-library": MessageSquareText,
  "projects": FolderKanban,
  "buenas-practicas": Lightbulb,
  "videos": Play,
  "casos-exito": Trophy,
  "faq": HelpCircle,
  "uso-seguro": ShieldCheck,
};

export function CategoryIcon({ slug, className = "h-5 w-5" }) {
  const Icon = ICON_MAP[slug] || Library;
  return <Icon className={className} />;
}
